import React, { useState } from "react";
import Card from "components/card";
import HistoryList from "./HistoryList";
import CartVoucher from "./CartVoucher";
import Button from "components/button";
import IndexModal from "components/modal";
import GiftVoucher from "./GiftVoucher";
import { displayIcon } from "variables/icons";

const StoreModal = ({ 
    type, 
    onClose, 
    itemList = [],
    onRemove,
    onUpdateQuantity,
 }) => {
    const [open, setOpen] = useState(false);

    if (type === "history") {
        return (
            <Card className="gap-4 rounded-xl border p-6 shadow-lg duration-200 sm:max-w-lg max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
                <div className="flex flex-col gap-2 text-center sm:text-left">
                    <h2 className="text-lg leading-none font-semibold flex items-center gap-2">
                        {displayIcon("History", "w-5 h-5")}
                        Gift Voucher History
                    </h2>
                    <p className="text-sm muted-text">
                        View all vouchers you've gifted to employees
                    </p>
                </div>
                <div className="relative flex-1 pr-4 overflow-y-auto">
                    <div className="rounded-[inherit] transition-[color,box-shadow] outline-none">
                        <div className="space-y-3">
                            <HistoryList />
                        </div>
                    </div>
                </div>
                {itemList.length === 0 && (
                    <div className="py-12 text-center muted-text">
                        {displayIcon("ShoppingCart", "w-12 h-12 mx-auto mb-4 opacity-50")}
                        <p>
                            Your cart is empty
                        </p>
                        <Button
                            onClick={onClose}
                            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all shrink-0 outline-none border bg-white text-slate-900 hover:bg-slate-100 hover:text-slate-900 h-9 px-4 py-2 mt-4 hover:shadow-none"
                        >
                            Continue Shopping
                        </Button>
                    </div>
                )}
            </Card>
        );
    }

    if (type === "cart") {
        return (
            <>
                <Card className="gap-4 rounded-lg border p-6 shadow-lg duration-200 max-h-[80vh] overflow-hidden flex flex-col">
                    <div className="flex flex-col gap-2 text-center sm:text-left">
                        <h2 className="text-lg leading-none font-semibold flex items-center gap-2">
                            {displayIcon("ShoppingCart", "w-5 h-5")}
                            Your Shopping Cart
                        </h2>
                        <p className="muted-text text-sm">
                            Review your items before checkout
                        </p>
                    </div>
                    {itemList?.length > 0 ? (
                        <>
                            <div className="relative flex-1 pr-4 overflow-y-auto">
                                <div className="rounded-[inherit] transition-[color,box-shadow] outline-none">
                                    <div className="space-y-3">
                                    {itemList?.map((item, index) => (
                                            <CartVoucher 
                                                key={index} 
                                                voucherItem={item}
                                                onRemove={onRemove}
                                                onUpdateQuantity={onUpdateQuantity}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="bg-slate-100 shrink-0 h-px w-full"></div>
                            <div className="space-y-3">
                                <div className="flex items-center justify-between">
                                    <span className="text-[14px] muted-text">
                                        Total Items:
                                    </span>
                                    <span className="font-medium">
                                        {itemList?.reduce((sum, item) => sum + item.quantity, 0)}
                                    </span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <span className="text-[14px] muted-text">
                                        Total Points:
                                    </span>
                                    <span className="font-bold text-[18px] text-emerald-600 flex items-center gap-1 dark:text-emerald-500">
                                        {displayIcon("Sparkles", "w-5 h-5")}
                                        {itemList?.reduce((sum, item) => sum + item.voucher?.points * item.quantity, 0)}
                                    </span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <span className="text-[14px] muted-text">
                                        Available Points:
                                    </span>
                                    <span className="font-medium">2,400</span>
                                </div>
                                <div className="flex gap-2">
                                    <Button
                                        onClick={onClose}
                                        className="flex-1 h-8 border rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center hover:shadow-none hover:bg-slate-100"
                                    >
                                        Continue Shopping
                                    </Button>

                                    <Button
                                        className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium outline-none h-8 rounded-md gap-1.5 px-3 flex-1 bg-gradient-to-r from-emerald-600 to-purple-600 hover:from-emerald-700 hover:to-purple-700 hover:shadow-none text-white"
                                        onClick={() => setOpen(true)}
                                    >
                                        {displayIcon("Check", "w-4 h-4 mr-1")}
                                        Checkout
                                    </Button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="py-12 text-center muted-text">
                            {displayIcon("ShoppingCart", "w-12 h-12 mx-auto mb-4 opacity-50")}
                            <p>
                                Your cart is empty
                            </p>
                            <Button
                                onClick={onClose}
                                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all shrink-0 outline-none border bg-white text-slate-900 hover:bg-slate-100 hover:text-slate-900 h-9 px-4 py-2 mt-4 hover:shadow-none"
                            >
                                Continue Shopping
                            </Button>
                        </div>
                    )}
                </Card>
                <IndexModal
                    open={open}
                    onClose={() => setOpen(false)}
                    useCustomClass={true}
                    maxContentHeight="708px"
                    width="512px"
                >
                    <GiftVoucher 
                        onClose={() => setOpen(false)}
                        cartItems={itemList}
                    />
                </IndexModal>
            </>
        );
    }

    return null;
};
export default StoreModal;